import React, { MouseEvent } from 'react';
import Table, { TableProps } from 'antd/lib/table';
import './TableNew.scss';
import ChevronIcon from '@shared/ui/icons/Chevron';
import { twMerge } from '@shared/utils/twMerge';

type NewTableProps<T> = TableProps<T & { disabled?: boolean }> & {
  tableClassName?: string;
};

export type TableRecord = {
  disabled?: boolean;
  id?: string;
  key?: string;
};

export const TableNew = <T extends TableRecord>(props: NewTableProps<T>) => {
  const { tableClassName, expandable, ...restProps } = props;
  const rowExpandable = () => !!expandable?.expandedRowRender;
  return (
    <Table
      {...restProps}
      expandable={{
        ...expandable,
        rowExpandable,
        expandIcon: ({ expanded, onExpand, record }) => {
          const dir = expanded ? 'up' : 'down';
          const handleClick = (e: MouseEvent<HTMLElement>) => {
            onExpand && !record?.disabled && onExpand(record, e);
          };
          const extraStyle = record?.disabled ? 'opacity-50 cursor-not-allowed' : '';
          return rowExpandable() ? (
            <ChevronIcon
              dir={dir}
              onClick={
                handleClick as (() => void) & ((e: MouseEvent<HTMLElement, MouseEvent>) => void)
              }
              classNameButton={twMerge(
                'bg-white border rounded-lg h-[2.4rem] w-[2.4rem] cursor-pointer',
                extraStyle
              )}
              className={extraStyle}
              dataTestid={`tableChevronIcon-${record?.id || record?.key}`}
            />
          ) : null;
        },
      }}
      className={twMerge(tableClassName)}
    />
  );
};
